import { render, staticRenderFns } from "./importar_generico.vue?vue&type=template&id=23ea6a17&"
import script from "./importar_generico.vue?vue&type=script&lang=js&"
export * from "./importar_generico.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports